/* eslint-disable */
// Prebid Config Section START
window.prebidConfig = {
    desktop: {
        appnexus: { adPointId: "3353552", placements: { "300x250": { ros: 10668251 }, "300x600": { ros: 10668252 }, "300x1050": { ros: 10668253 }, "970x250": { ros: 10668250 } } },
        colossusssp: { adPointId: "6745978", placements: { leaderboard_btf: { placement_id: "21939" }, poster: { placement_id: "21937" }, poster_scroll: { placement_id: "21938" } } },
        criteo: { adPointId: "3347031", networkId: 1493 },
        ix: {
            adPointId: "3357003",
            placements: { leaderboard_atf: { id: 2, siteId: "736779" }, leaderboard_btf: { id: 3, siteId: "196727" }, poster: { id: 4, siteId: "196728" }, poster_scroll: { id: 8, siteId: "196732" } },
            identityLib: { scriptUrl: "https://js-sec.indexww.com/ht/p/184808-190681299057122.js", timeout: 200 },
        },
        medianet: {
            adPointId: "50349531",
            cid: "8CUM5GF61",
            placements: { "970x250": { crid: "413536461" }, "300x250": { crid: "413536461" }, "300x600": { crid: "413536461" }, "300x1050": { crid: "413536461" }, "728x90": { crid: "413536461" } },
        },
        openx: {
            adPointId: "3355968",
            domain: "gannett-d.openx.net",
            placements: { "300x250": "538809232", "300x600": "538809234", "300x1050": "538809236", "970x250": "538809235", "728x90": "540401032" },
        },
        pubmatic: {
            enabled: !1,
            adPointId: "2616245",
            account: "57752",
            placements: ["ATF@728x90", "BTF@728x90", "ATF@300x250", "BTF@300x250", "ATF@300x600", "ROS@970x250", "ROS@300x1050"],
            placementMap: { poster: "USATODAY.com_poster", poster_scroll: "USATODAY.com_poster_scroll", leaderboard_btf: "USATODAY.com_leaderboard-btf", leaderboard_atf: "USATODAY.com_leaderboard-atf" },
        },
        rubicon: { adPointId: "3342134", account: "11324", siteId: "29970", zoneId: 120284 },
        smaato: { adPointId: "49885406", publisherId: "1100056173", adspaceId: "135836771" },
        sonobi: { adPointId: "3353351" },
        taboola: { publisherId: "1468240", sizes: ["970x250", "728x90", "300x250", "320x50", "300x50", "300x600"], adPointId: "7599891" },
        triplelift: { adPointId: "2615974", multisize: !1, placements: { "300x600": { id: "usatoday_300x600_desktop" }, "970x250": { id: "usatoday_970x250_desktop" } } },
        trustx: { adPointId: "6745584", multisize: !1, placements: { poster: 3779 , poster_scroll: 3779}, floor: 3 },
        undertone: { adPointId: "46107981", multisize: !1, publisherId: 113, placements: { "300x250": { placementId: 113015 }, "300x600": { placementId: 113019 }, "728x90": { placementId: 113017 }, "970x250": { placementId: 113025 } } },
        yahoossp: {
            adPointId: "3341509",
            placements: {
                "300x250": { dcn: "8a969d030176764773184831dc370011", pos: "8a969d0301767647731848343cd60014" },
                "300x600": { dcn: "8a969d030176764773184831dc370011", pos: "8a969d0301767647731848343ddf0015" },
                "728x90": { dcn: "8a969d030176764773184831dc370011", pos: "8a9695f7017676477a7748343ee50016" },
                "970x250": { dcn: "8a969d030176764773184831dc370011", pos: "8a9691fb0176764776a348343fd5001c" },
                "300x1050": { dcn: "8a969d030176764773184831dc370011", pos: "8a9691fb0176764776a348343bd6001b" },
            },
            multisize: !1,
        },
        yieldmo: { adPointId: "29550683", placementId: "0x21783cc7b6bf2000" },
        teads: { multisize: !1, adPointId: "3425476", placements: { "640x360": { placementId: 128712, pageId: 118635 }, "300x250": { placementId: 134024, pageId: 118635 } } },
    },
    mobile: {
        appnexus: { placements: { "300x250": { id: 11019790, ros: 11019790 }, "320x50": { id: 11019640, ros: 11019640 } } },
        colossusssp: { placements: { "mobileweb-banner_bottom": { placement_id: "21941" }, "mobileweb-banner_top": { placement_id: "21940" } } },
        criteo: { networkId: 1493 },
        ix: {
            placements: { "mobileweb-banner_bottom": { id: 11, siteId: "196735" }, "mobileweb-banner_top": { id: 13, siteId: "196737" } },
            identityLib: { scriptUrl: "https://js-sec.indexww.com/ht/p/184808-190681299057122.js", timeout: 200 },
        },
        medianet: {
            cid: "8CUM5GF61",
            placements: { "320x50": { crid: "259883354" }, "300x250": { crid: "259883354" }, "300x600": { crid: "259883354" }, "320x480": { crid: "259883354" }, "320x180": { crid: "259883354" } },
        },
        openx: { domain: "gannett-d.openx.net", placements: { "320x50": "539135067", "300x250": "539135067" } },
        pubmatic: {
            enabled: !1,
            account: "57752",
            placements: ["MWebATF@300x250", "MWebBTF@300x250", "ROS@320x50"],
            placementMap: { "mobileweb-banner_top": "USATODAY.com_mobileweb-banner_top", "mobileweb-banner_bottom": "USATODAY.com_mobileweb-banner_bottom" },
        },
        rubicon: { account: "11324", siteId: "31170", zoneId: 372742 },
        smaato: { publisherId: "1100056173", adspaceId: "135836771" },
        sonobi: { },
        taboola: { publisherId: "1468240", sizes: ["300x250", "320x50", "300x50"], },
        triplelift: { multisize: !1, placements: { "300x250": { id: "usatoday_300x250_mobile" } } },
        trustx: { placements: { "mobileweb-banner_bottom": 3780, "mobileweb-banner_top":3780}, floor: 3 },
        undertone: { multisize: !1, publisherId: 113, placements: { "300x250": { placementId: 113015 }, "320x50": { placementId: 113021 } } },
        yahoossp: { placements: { "300x250": { dcn: "8a9695f7017676477a774831dd260013", pos: "8a969d03017676477318483440cc0016" } }, multisize: !1 },
        yieldmo: { placementId: "241174442908681e4" },
        teads: { multisize: !1,  placements: { "300x250": { placementId: 134024, pageId: 118635 }, "320x180": { placementId: 128712, pageId: 118635 } } },
    },
};

window.adCount = 1;

window.pbjs = window.pbjs || {};
window.pbjs.que = window.pbjs.que || [];
window.pbjs.que.push(function() {
  var pbConfig = {
    bidderTimeout: 1600,
    priceGranularity: {
      buckets: [
      {
        precision: 2,
        min: 0,
        max: 10,
        increment: 0.01
      },
      {
        precision: 2,
        min: 10,
        max: 20,
        increment: 0.05
      },
      {
        precision: 2,
        min: 20,
        max: 50,
        increment: 0.10
      },
      {
        precision: 2,
        min: 50,
        max: 75,
        increment: 0.25
      },
      {
        precision: 2,
        min: 75,
        max: 100,
        increment: 0.50
      },
      {
        precision: 2,
        min: 100,
        max: 200,
        increment: 1.00
      },
      {
        precision: 2,
        min: 200,
        max: 480,
        increment: 5.00
      }
      ]
    },
    cache: {
      url: 'https://prebid.adnxs.com/pbc/v1/cache'
    },
    bidderSequence: prebidConfig.bidderSequence || 'random',
    enableSendAllBids: false,
    usePrebidCache: true,
    maxRequestsPerOrigin: 99,
    timeoutBuffer: 400,
    userSync: {
      syncEnabled: true,
      filterSettings: {
        iframe: {
          bidders: ['colossusssp', 'criteo', 'medianet', 'openx', 'pubmatic', 'smaato', 'sonobi', 'triplelift', 'trustx', 'yahoossp'],
          filter: 'exclude'
        }
      },
      syncsPerBidder: 5
    },
    rubicon: { singleRequest: true },
    useBidCache: true,
    s2sConfig: {
      accountId: 'gannett',
      bidders: ['appnexus','appnexusAst','colossusssp','ix','medianet','openx','pubmatic','pulsepoint','rubicon','smaato','sonobi','triplelift','trustx','undertone','yieldmo','yahoossp'],
      extPrebid: {
        aliases: {
          appnexusAst: 'appnexus',
          colossusssp: 'colossus',
          yahoossp: 'yahooAds'
        }
      },
      enabled: true,
      syncEndpoint: 'https://www.usatoday.com/pbd/cookie_sync',
      endpoint: 'https://www.usatoday.com/pbd/openrtb2/auction',
      timeout: 1000
    }
  };
  if (window.__gpp) {
    pbConfig.consentManagement = {
      gpp: {
        cmpApi: 'iab'
      }
    }
  }
  window.pbjs.setConfig(pbConfig);

  window.pbjs.bidderSettings = {
    standard: {
      adserverTargeting: [
        {
          key: "hb_ap",
          val: function(bidResponse) {
            return bidResponse.pbCg;
          }
        },
        {
          key: "hb_bidder",
          val: function(bidResponse) {
            return bidResponse.bidderCode;
          }
        },
        {
          key: "hb_adid",
          val: function(bidResponse) {
            return bidResponse.adId;
          }
        },
        {
          key: 'hb_size',
          val: function(bidResponse) {
            return bidResponse.size;
          }
        },
        {
          key: 'hb_source',
          val: function(bidResponse) {
            return bidResponse.source;
          }
        },
        {
          key: 'hb_format',
          val: function(bidResponse) {
            return bidResponse.mediaType;
          }
        },
        {
          key: 'hb_ap_id',
          val: function(bidResponse) {
            var adPointId = window.prebidConfig.desktop[bidResponse.bidderCode] && window.prebidConfig.desktop[bidResponse.bidderCode].adPointId;
            return adPointId;
          }
        },
        {
          key: 'hb_deal',
          val: function(bidResponse) {
            return bidResponse.dealId;
          }
        }
      ]
    },
    openx: {
      adserverTargeting: [{
        key: 'ff',
        val: function(bidResponse) {
          return bidResponse.openx && bidResponse.openx.ff;
        }
      }, {
        key: 'oxcolo',
        val: function(bidResponse) {
          return bidResponse.openx && bidResponse.openx.oxcolo;
        }
      }, {
        key: 'oxph',
        val: function(bidResponse) {
          return bidResponse.openx && bidResponse.openx.oxph;
        }
      }]
    }
  };
});
// Prebid Config Section END

window.dataToSend = [];
window.a9Slots = {};

export function getbids(divId, adUnit, adSizes, gpid) {
  var adConfig = window.innerWidth <= 768 ? window.prebidConfig.mobile : window.prebidConfig.desktop,
    location = (adUnit.indexOf('_btf') > -1) ? 'btf' : 'atf',
    section = 'entertainment',
    topic = '',
    sstsParts = ['entertainment', 'games'],
    bids = [];

  setupAppNexus(bids, adConfig.appnexus || adConfig.appNexus || {}, adSizes, adUnit, section, sstsParts, topic);
  setupColossusssp(bids, adConfig.colossusssp || {}, adUnit);
  setupCriteo(bids, adConfig.criteo || {});
  setupIX(bids, adConfig.ix || {}, adSizes, adUnit);
  setupMediaNet(bids, adConfig.medianet || adConfig.medianet || {}, adSizes);
  setupOpenX(bids, adConfig.openx || adConfig.openX || {}, adSizes, section);
  setupRubicon(bids, adConfig.rubicon || {}, location, section);
  setupSmaato(bids, adConfig.smaato || {});
  setupSonobi(bids, adConfig.sonobi || {}, adUnit, divId);
  setupTaboola(bids, adConfig.taboola || {}, adSizes, gpid);
  setupTeads(bids, adConfig.teads || {}, adSizes);
  setupTripleLift(bids, adConfig.triplelift || {}, adSizes);
  setupTrustx(bids, adConfig.trustx || {}, adSizes, adUnit, topic);
  setupUndertone(bids, adConfig.undertone || {}, adSizes);
  setupYieldmo(bids, adConfig.yieldmo || {});
  setupYahoo(bids, adConfig.yahoossp || {}, adSizes);

  return bids;
}

export function setupAppNexus(bids, config, sizes, adUnit, section, sstsParts, topics) {
  var placements, subsection;

  if (config) {
    sizes.forEach(function (size) {
      var placement = config.placements[size[0] +'x' + size[1]];
      if (placement) {
        subsection = sstsParts[1] || '';
        bids.push({
          bidder: 'appnexus',
          params: {
            placementId: placement.ros,
            keywords: {
              position: adUnit.split('/')[2],
              section: [section],
              subsection: [subsection],
              topic: [],
              brandsafety: ''
            }
          }
        });
      }
    });
  }
}

export function setupColossusssp(bids, config, adUnit) {
  var placement,
  key = adUnit.split('/')[3];

  if (config && key) {
    placement = config.placements && config.placements[key];
    if (placement) {
      bids.push({
        bidder: 'colossusssp',
        params: {
          TagID: placement.placement_id
        }
      });
    }
  }
}

export function setupCriteo(bids, config) {
  if (config) {
    bids.push({
      bidder: 'criteo',
      params: {
        networkId: config.networkId
      }
    });
  }
}

export function setupIX(bids, config, sizes, adUnit) {
  var placement, matches,
  key = adUnit.split('/')[3];
  if (config) {
    placement = config.placements[key];
    if (placement) {
      sizes.forEach(function(size) {
        bids.push({
          bidder: 'ix',
          params: Object.assign(placement, { size: size })
        });
      });
    }
  }
}

export function setupMediaNet(bids, config, sizes) {
  sizes.forEach(function (size) {
    var placement = config.placements[size[0] +'x' + size[1]];
    if (placement) {
      bids.push({
        bidder: 'medianet',
        params: {
          cid: config.cid,
          crid: placement.crid
        }
      });
    }
  });
}

export function setupOpenX(bids, config, sizes, section) {
  sizes.forEach(function (size) {
    var placement = config.placements[size[0] +'x' + size[1]];
    if (placement) {
      bids.push({
        bidder: 'openx',
        params: {
          unit: placement,
          delDomain: config.domain
        }
      });
    }
  });
}

export function setupPubmatic(bids, config, location, sizes) {
  var adSize = getMaxSize(sizes);

  if (!adSize) { return; }

  var adSizeString = adSize[0] + 'x' + adSize[1],
  slot = location.toUpperCase() + '@' + adSizeString,
  rosSlot = 'ROS@' + adSizeString,
  slots = config.slots || [],
  adSlot = (slots.indexOf(slot) > -1) ? slot : (slots.indexOf(rosSlot) > -1) ? rosSlot : null;

  if (config && adSlot) {
    bids.push({
      bidder: 'pubmatic',
      params: {
        publisherId: config.account,
        adSlot: adSlot
      }
    });
  }
}

export function setupRubicon(bids, config, location, section) {
  var subsection, topicArr,
  zoneId = config.zoneId;

  bids.push({
    bidder: 'rubicon',
    params: {
      accountId: config.account,
      siteId: config.siteId,
      zoneId: zoneId,
      inventory: {
        domain: [document.location.hostname],
        section: [section],
        subsection: ['games'],
        topic: [],
        brandsafety: []
      },
      position: (location === 'atf') ? location : ''
    }
  });
}

export function setupSonobi(bids, config, adUnit, divId) {
  bids.push({
    bidder: 'sonobi',
    params: {
      dom_id: divId,
      ad_unit: adUnit,
      TagID: adUnit
    }
  });
}

export function setupSmaato(bids, config) {
  bids.push({
    bidder: 'smaato',
    params: {
      publisherId: config.publisherId,
      adspaceId: config.adspaceId
    }
  });
}

export function setupTaboola (bids, config, adUnitSizes, gpid) {
  var isValid = adUnitSizes.some(function(s) { config.sizes.includes(`${s[0]}x${s[1]}`) });
  if (isValid) {
    bids.push({
      bidder: 'taboola',
      params: {
        tagId: gpid,
        publisherId: config.publisherId
      }
    });
  }
}

export function setupTeads(bids, config, sizes) {
  sizes.forEach(function (size) {
    var placement = config.placements[size[0] +'x' + size[1]];
    if (placement) {
      bids.push({
        bidder: 'teads',
        params: {
          placementId: placement.placementId,
          pageId: placement.pageId
        }
      });
    }
  });
}

export function setupTripleLift(bids, config, sizes) {
  sizes.forEach(function (size) {
    var placement = config.placements[size[0] +'x' + size[1]];
    if (placement) {
      bids.push({
        bidder: 'triplelift',
        params: {
          inventoryCode: placement.id
        }
      });
    }
  });
}

export function setupTrustx(bids, config, adUnitSizes, adUnitPath) {
  var placement = config.placements[adUnitPath.split('/')[3]];
  if (placement) {
    bids.push({
      bidder: 'trustx',
      params: {
        uid: placement,
        keywords: {
          topic: [],
          brandsafety: []
        }
      }
    });
  }
}

export function setupUndertone(bids, config, sizes) {
  sizes.forEach(function (size) {
    var placement = config.placements[size[0] +'x' + size[1]];
    if (placement) {
      bids.push({
        bidder: 'undertone',
        params: {
          publisherId: config.publisherId,
          placementId: placement.placementId
        }
      });
    }
  });
}

export function setupYahoo(bids, config, sizes) {
  sizes.forEach(function (size) {
    var placement = config.placements[size[0] +'x' + size[1]];
    if (placement) {
      bids.push({
        bidder: 'yahooAds',
        params: {
          dcn: placement.dcn,
          pos: placement.pos
        }
      });
    }
  });
}

export function setupYieldmo(bids, config) {
  bids.push({
    bidder: 'yieldmo',
    params: {
      placementId: config.placementId.toString()
    }
  });
}

export function getMaxSize(sizes) {
  var adSize;

  if (sizes.length > 1) {
    // if larger size
    sizes.reduce(function(memo, size) {
      var total = size[0] + size[1];
      if (total > memo) {
        adSize = size;
        return total;
      }
      return memo;
    }, 0);
  } else {
    // If single size return it
    adSize = sizes[0];
  }

  return adSize;
}

export function cobrandCallForAd(divId, adUnit, adSizes, customTargeting, cb) {
  if (typeof adUnit !== 'string') {
    return false;
  }

  var gpid = adUnit + '/' + window.adCount++;

  adSizes = adSizes || [[300, 250], [300, 600]];
  try {
    window.dataToSend.push({
      code: divId,
      mediaTypes: {
        banner: {
          sizes: adSizes
        }
      },
      bids: getbids(divId, adUnit, adSizes, gpid) || [],
      ortb2Imp: {
        ext: {
          data: {
            adserver: {
              adslot: gpid,
              name: 'gam'
            },
            pbadslot: gpid
          },
          gpid: gpid
        }
      }
    });
  } catch (e) {
    console.error('Failed to setup bids', adUnit);
  }

  window.a9Slots[divId] = {
      slotID: divId,
      sizes: adSizes
  };

  customTargeting = customTargeting || {};
  customTargeting.position = adUnit.split('/')[3];
  window.googletag.cmd.push(function() {
    var slotRef = window.googletag.defineSlot(adUnit, adSizes, divId).addService(window.googletag.pubads());
    for (var name in customTargeting) {
      if (customTargeting.hasOwnProperty(name)) {
        slotRef.setTargeting(name, customTargeting[name]);
      }
    }
    cb(slotRef);
    window.googletag.display(divId);
  });
}
//# sourceURL=inline-ads.js

(function() {
  var e, s;
  var config = {"refreshBlocked": true, "enabled": true, "scriptUrl": "https://cdn.confiant-integrations.net/r5TdgVvkbv-PeaJCKaQfCh5Xsto/gpt_and_prebid/config.js"};

  if (config && config.enabled || window.location.search.indexOf('confiant_debug') !== -1) {
    window.confiant = window.confiant || {};
    window.confiant.enable_integrations = ['gpt'];

    e = document.createElement('script');
    e.async = true;
    e.src = config && config.scriptUrl;
    s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(e, s);
  }
})();
